import React from "react";
import {Modal} from "antd";
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { URL_SALE } from "../../constants/urls";
import { PRODUCT_TYPE } from "../../constants/string";
import { dateToHumanString, formatComma } from "../../frameworks/Util";

export default function SkimWaitingOrderListModal(props){
  const { open, onClose } = props;
  const tableRef = React.useRef(null);

  const columns = [
    {
      title : 'วันที่',
      dataIndex : 'created',
      key : 'created',
      render : (value) => dateToHumanString(value)
    },
    {
      title : 'Lot No',
      dataIndex : 'lot_no',
      key : 'lot_no',
      searcher : true,
    },
    {
      title : 'Produce by',
      dataIndex : 'produce_by',
      key : 'produce_by',
      searcher : true,
    },
    {
      title : 'ชื่อลูกค้า',
      dataIndex : 'buyer_name',
      key : 'buyer_name'
    },
    {
      title : 'สินค้าที่ต้องการ',
      dataIndex : 'product_name',
      key : 'product_name'
    },
    {
      title : 'ปริมาณที่ต้องการ(Kg)',
      dataIndex : 'require_weight',
      key : 'require_weight',
      render : (value) => <center>{formatComma(value)}</center>
    },
    {
      title : 'ปริมาณที่ต้องการ(ก้อน)',
      dataIndex : 'require_amount',
      align : 'center',
      key : 'require_amount',
    },
    {
      title : 'ผู้แจ้งผลิต',
      dataIndex : 'created_by_name',
      key : 'created_by_name'
    },
    {
      title : 'สถานะ',
      dataIndex : 'is_produced',
      key : 'is_produced',
      render : (value) => value ? 'ผลิตแล้ว' : 'รอผลิต'
    },
  ]

  return(
    <Modal
      title={"ใบแจ้งผลิตที่รอผลิต"}
      open={open}
      onCancel={onClose}
      okText={"ตกลง"}
      cancelText={"ยกเลิก"}
      width={1000}
      destroyOnClose
      footer={[
        <ColorButton onClick={()=> onClose()}>ปิด</ColorButton>
      ]}
    >
      <TSTable
        ref={tableRef}
        columns={columns}
        size={"small"}
        url={URL_SALE.SKIM_PRODUCE_ORDER}
        params={{ type: PRODUCT_TYPE.CONCENTRATE_LATEX, is_produced : false }}
      />

    </Modal>
    
  )
}